// extracted by mini-css-extract-plugin
export default {"NoOrders":"Orders_NoOrders__MSbmt","HeaderTab":"Orders_HeaderTab__+U9S5","AllOrders":"Orders_AllOrders__ai+wk","Error":"Orders_Error__Lbw2G","GetStarted":"Orders_GetStarted__ejqu6"};